export class Element {
  options = {}

  constructor (options) {
    this.type = options.type
    this.options.title = options.title || ''
    this.options.span = options.span || 6
    this.options.labelClass = options.labelClass || 'detail-text-label'
    if (options.query) {
      this.options.query = options.query
    }
    this.options.placeholder = options.placeholder || ''

    this.options.getter = options.getter
    this.options.setter = options.setter
    this.options.trans = options.trans || ''
    this.options.watcher = options.watch || ''
    this.options.options = options.options || ''
    this.options.disabled = options.disabled || false

    if (options.width) {
      this.options.width = options.width
    }
    if (options.autocomplete) {
      this.options.autocomplete = options.autocomplete
    }
    if (options.defaultValue !== undefined) {
      this.options.defaultValue = options.defaultValue
    }

    if (options.isRequire) {
      this.options.isRequire = options.isRequire
    }

    if (options.needBus) {
      this.options.needBus = true
    }
  }

  tpl () {
    return this.type
  }

  props () {
    return this.options
  }

  hasTitle () {
    return this.title !== ''
  }
}

export function make (config) {
  return new Element({ ...config })
}

export class TableProp {
  options = {}
  constructor (options) {
    this.options.label = options.label || ''
    this.options.className = options.className || ''
    if (options.width) {
      this.options.width = options.width
    }
    this.options.align = options.align || 'left'
    this.options.prop = options.prop
    this.options.tag = options.tag || ''
    this.options.rowKey = options.rowKey || ''
    this.options.setter = options.setter || ''
    this.options.getter = options.getter || ''
    this.options.trans = options.trans || ''
  }

  isProp () {
    return true
  }
  props () {
    return this.options
  }
}

export class CustomerCell extends TableProp {
  isProp () {
    return false
  }
}

export function makeTable (config) {
  switch (config.prop) {
    case 'ColumnStockDropDown':
    case 'ColumnStockDropDownSingleStk':
    case 'ColumnLocationDialog':
    case 'ColumnProductCodePopover':
    case 'ColumnDeliverStatus':
    case 'ColumnShippingType':
    case 'BillHistory':
    case 'ColumnAddToCart':
    case 'ColumnPriceDropDown':
    case 'ColumnPriceDropDownWithInput':
    case 'ColumnProductCodeSelectPopper':
    case 'ColumnProductNameInput':
    case 'ColumnLineAmount':
    case 'ColumnInputDesc':
    case 'ColumnInputQty':
    case 'ColumnLineTaxType':
    case 'ColumnInputInQty':
    case 'ColumnInputSysQty':
    case 'ColumnProductCostPrice':
    case 'ColumnLineQtyBalance':
    case 'ColumnShow':
    case 'ColumnIconShow':
    case 'ColumnViewBtn':
    case 'ColumnViewBaseinfoBtn':
      return new CustomerCell({ ...config })
    default:
      return new TableProp({ ...config })
  }
}
